module.exports = __webpack_public_path__ + "static/img/webpic003.9ff6ff6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/webpic003.jpg
// module id = l0FF
// module chunks = 1